import React from 'react'
import { useTranslation } from 'react-i18next'

const SubCategoryNav = ({ 
  subCategories = [], 
  activeSubCategory = '', 
  onSubCategoryChange,
  currentCategoryName = '',
  className = ""
}) => {
  const { t } = useTranslation()

  if (subCategories.length === 0) {
    return null
  }

  return (
    <div className={`sub-category-nav ${className}`}>
      {/* 当前分类信息 */}
      {currentCategoryName && (
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            {t('products.subCategoryNav.currentCategory', { category: currentCategoryName })}
          </h3>
        </div>
      )}

      {/* 子分类标签 */}
      <div className="flex flex-wrap gap-2">
        {/* 全部子分类 */}
        <button
          onClick={() => onSubCategoryChange('')}
          className={`sub-category-tag px-4 py-2 text-sm rounded-full border transition-all duration-200
                     ${activeSubCategory === ''
                       ? 'bg-primary-600 text-white border-primary-600'
                       : 'bg-white text-gray-700 border-gray-300 hover:border-primary-400 hover:text-primary-600'}`}
        >
          {t('products.subCategoryNav.allSubCategories')}
        </button>

        {/* 具体子分类 */}
        {subCategories.map((subCategory) => (
          <button
            key={subCategory.id}
            onClick={() => onSubCategoryChange(subCategory.id)}
            className={`sub-category-tag px-4 py-2 text-sm rounded-full border transition-all duration-200
                       ${activeSubCategory === subCategory.id
                         ? 'bg-primary-600 text-white border-primary-600'
                         : 'bg-white text-gray-700 border-gray-300 hover:border-primary-400 hover:text-primary-600'}`}
          >
            {subCategory.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default SubCategoryNav 